<template>
  <div>
    <div class="page">
      <div class="page__container">

        <header>
          <div class="header">
            <a href='https://ipnet.ua' target="_blank" class="header__logo">
              <img src="../../assets/logo.svg" alt="">
            </a>
            <span class="header__contacts">
              <span class="phone">
                <a href="tel:+380445070505">(044) 507 05 05</a>
              </span>
              <span class="hide-768">
                &nbsp;&nbsp;|&nbsp;&nbsp;
              </span>
              <a href="https://ipnet.ua" class="site" target="_blank">
                ipnet.ua
              </a>
            </span>
          </div>

          <div class="main-picture">
            <div>
              <div class="picture-title">
                <span class="picture-title__type">{{ cardOptions.type }}</span>
                <span class="picture-title__name">{{ cardOptions.name }}</span>
              </div>
              <img src="../../assets/start69/69.png" class="picture" alt="">
            </div>
          </div>
        </header>

        <div class="main__container">
          <CardItemHorizontalSimpleWithForm
              :card-options="cardOptions"
              :header-color="headerColor"
              :accent-color="accentColor"
              :landing-codename="landingCodename"
              :ga-tag="'start69_order_middle'"></CardItemHorizontalSimpleWithForm>
        </div>
      </div>
    </div>

    <Advantages :advantagesOptions="advantagesOptions"></Advantages>
    <CoverMap :landingCodename="landingCodename"
              :under-text-form="cardOptions.underText"
              :gaFormTag="'start69_order_bottom_map'"></CoverMap>
    <footer-section></footer-section>
    <SeoTextToggle :text="seoTextsToggle"></SeoTextToggle>
  </div>
</template>

<script>
import FooterSection from "../../components/FooterSection";
import Advantages from "../../components/Advantages";
import SeoTextToggle from "../../components/SeoTextToggle";
import CoverMap from "../../components/CoverMap";
import cardOptions from './cardOptions'
import CardItemHorizontalSimpleWithForm from "../../components/CardItemHorizontalWithForm";
import seoTextsToggle from "./seoTexts";

export default {
  name: "Start69",
  components: {
    FooterSection,
    CardItemHorizontalSimpleWithForm,
    Advantages,
    CoverMap,
    SeoTextToggle
  },
  metaInfo: {
    title: 'Домашній Інтернет 69 грн | IPnet',
    titleTemplate: null,
    meta: [{
      vmid: 'description',
      name: 'description',
      content: 'Акція 69 грн на домашній Інтернет IPnet Старт.',
    }]
  },

  data() {
    this.accentColor = '#ff3737'
    this.headerColor = '#4868c5'

    this.$vuetify.theme.themes.light.primary = this.accentColor
    this.landingCodename = 'start69'

    this.advantagesOptions = {
      title: 'ДОДАТКОВІ ПЕРЕВАГИ ВІД КОМПАНІЇ IPNET',
      options: [
        {
          text: 'БЕЗЛІМІТНИЙ ІНТЕРНЕТ',
          icon: require('../../assets/icons/advantages-unlim.png')
        },
        {
          text: 'ТЕХНІЧНА ПІДТРИМКА 24/7',
          icon: require('../../assets/icons/advantages-support.png')
        },
        {
          text: 'ЦИФРОВЕ ТЕЛЕБАЧЕННЯ',
          icon: require('../../assets/icons/advantages-tv.png')
        }
      ]
    }

    return {
      cardOptions: cardOptions,
      accentColor: this.accentColor,
      headerColor: this.headerColor,
      advantagesOptions: this.advantagesOptions,
      landingCodename: this.landingCodename,
      seoTextsToggle: seoTextsToggle
    }
  }
}
</script>

<style>
#app .v-application--wrap {
  min-width: 310px !important;
}
</style>

<style scoped>
>>> .additional-advantages, .footer {
  background-color: #4868c5;
}

.page {
  overflow: hidden;
  display: flex;
  justify-content: center;
  background: linear-gradient(0deg, #4868c5 0%, #e6a58c 100%);
}

.page__container {
  min-width: 300px;
  max-width: 1000px;
  margin: 0 auto;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
}

/* HEADER */

header {
  width: 100%;
}

.header {
  position: relative;
  height: 130px;
  z-index: 2;
}

.header img {
  width: 100%;
  height: auto;
  display: block;
}

.header__logo {
  position: absolute;
  width: 152px;
  height: 101px;
  top: 12%;
  filter: brightness(0) invert(1);
}

.header__contacts {
  position: absolute;
  display: flex;
  right: 2%;
  top: 50%;
  font-size: 26px;
  color: #ffffff;
  font-weight: 500;
}

.header__contacts a {
  text-decoration: none;
  color: #ffffff;
}

/* TARIFF PICTURE */

.main-picture {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: -80px;
  z-index: 1;
}

.picture-title {
  height: 346px;
  position: absolute;
  display: flex;
  flex-direction: column;
  text-align: center;
  justify-content: center;
  width: 521px;
  font-family: Verdana, sans-serif;
  font-weight: 1000;
  line-height: normal;
  margin-top: 30px;
  margin-left: 350px;
  z-index: 2;
}

.picture-title__type {
  font-size: 40px;
  color: white;
  letter-spacing: 4px;
  text-transform: uppercase;
}

.picture-title__name {
  font-size: 60px;
  color: #ffd24f;
  letter-spacing: 3px;
}

.picture {
  margin-left: 400px;
  height: 729px;
  position: relative;
  z-index: 1;
}

/* MAIN */

.main__container {
  width: 100%;
  z-index: 2;
  position: relative;
  margin-top: -185px;
}

/* MEDIA */

@media (max-width: 1024px) {
  .page__container {
    max-width: 80%;
  }

  .main-picture {
    margin-top: unset;
  }

  .picture-title {
    position: relative;
    height: unset;
    z-index: 2;
    margin: 30px auto;
  }

  .picture-title__type {
    font-size: 35px;
  }

  .picture-title__name {
    font-size: 65px;
  }

  .picture {
    margin-left: unset;
    margin-top: -70px;
  }
}

@media (max-width: 768px) {
  .hide-768 {
    display: none;
  }

  .header__logo {
    width: 120px;
  }

  .header__contacts {
    display: flex;
    top: 32%;
    flex-direction: column;
    align-items: flex-end;
    font-size: 22px;
  }

  .page__container {
    max-width: 90%;
  }
}

@media (max-width: 500px) {
  .picture {
    height: 100vw;
    min-height: 370px;
    margin-top: -60px;
  }

  .picture-title__type {
    font-size: 25px;
    letter-spacing: 2px;
  }

  .picture-title__name {
    font-size: 50px;
  }

  .main__container {
    margin-top: -22vw;
  }
}

@media (max-width: 400px) {
  .picture-title__type {
    font-size: 20px;
    letter-spacing: 1px;
  }

  .picture-title__name {
    font-size: 40px;
    letter-spacing: 1px;
  }

  .picture {
    height: 370px;
    min-height: 370px;
    margin-top: -60px;
  }

  .picture-title {
    width: 280px;
  }

  .main__container {
    margin-top: -80px;
  }
}

</style>
